"use client";

import { motion } from "framer-motion";
import OrbitalAnimation from "./orbit";
import Link from "next/link";
import BookingModal from "../modal/booking-modal";
import { useState } from "react";

export default function HeroSection() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  return (
    <>
    <section className="relative overflow-hidden bg-[#F7F7F9]">
      <div className="container mx-auto px-6 lg:px-12 py-24">
        <div className="grid lg:grid-cols-2 gap-10 items-center">

          {/* Left Content */}
          <div className="py-14">
<span className="border-1 border-gray-400 px-2 py-1 rounded-full text-gray-500">AI & Product Development Partner</span>

            <h1 className="mt-5 text-5xl lg:text-7xl font-medium leading-[1.05] tracking-tight text-[#0F172A]">
            Build   
              {/* <br /> */}
              {" "}
              <span className="relative inline-block">
              AI-Powered
                <span className="absolute bottom-1 left-0 w-full h-[4px] bg-orange-400 rounded-full" />
              </span>
              <br />
              Products That Scale
            </h1>

            <p className="mt-6 max-w-xl text-xl leading-relaxed text-gray-600">
            AI automation, SaaS development, mobile apps, and custom software built to help startups and businesses launch faster and grow with confidence.  
             {/* <span className=" text-semibold">{" "}Fast, without compromising scalability.</span> */}
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
            <button  onClick={() =>
                      setIsBookingModalOpen(true)
                    }
                     className="bg-[#0F172A] cursor-pointer text-white px-8 py-4 rounded-2xl font-semibold hover:bg-black transition">
                Book a Free Strategy Call →
              </button>

              <Link href={'/case-studies'}>   <button  className="border cursor-pointer border-gray-300 bg-white px-8 py-4 rounded-2xl font-semibold text-[#0F172A] hover:bg-gray-50 transition">
                View Case Studies 
              </button></Link>
            </div>
          </div>


          {/* Right Illustration */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="order-2 flex items-center justify-center lg:justify-end py-16 lg:py-8 relative z-10"
          >
            <div className="w-[220px] h-[220px] sm:w-[320px] sm:h-[320px] md:w-[380px] md:h-[380px] lg:w-[420px] lg:h-[420px] relative opacity-95 mb-12">
              <OrbitalAnimation />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
    
    <BookingModal
        open={isBookingModalOpen}
        onClose={() =>
          setIsBookingModalOpen(false)
        }
      />
      </>
  );
}
